import { HelmetProvider } from 'react-helmet-async';

import Pages from './pages/Pages';
import WalletWrapper from './components/layouts/WalletWrapper';

function App() {
  return (
    <>
      <HelmetProvider>
        <WalletWrapper>
        <Pages />
        </WalletWrapper>
      </HelmetProvider>
    </>
  );
}

export default App;
